<template>
    <v-container id="dashboard" fluid tag="section">
        <base-v-component heading="Hotels - Dashboard" link="components/forms" />
    </v-container>
</template>

<script>
    export default {
        name: 'DashboardDashboard',

        data () {
            return {
            };
        },

        computed: {

        },

        methods: {

        }
    };
</script>

<style scoped>

</style>
